<template>
  <div>
    <div class="p-2 border border-danger text-danger font-weight-bold rounded-lg mb-3 rounded bg-white" v-if="_error">
      {{ _error }}
    </div>

    <div class="p-2 border border-success text-success font-weight-bold rounded-lg mb-3 rounded bg-white" v-if="_success">
      {{ _success }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['_error', '_success', '_loading'],
  name: "Alerts"
}
</script>

<style scoped>

</style>
